(() => {
  'use strict';
  const configNode = document.getElementById('baroona-birthday-price-config');
  if (!configNode || configNode.dataset.initialized) return;
  configNode.dataset.initialized = 'true';
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (config.currency !== 'AUD') return;
  const start = Date.parse(config.startsAt);
  const end = Date.parse(config.endsAt);
  const inPeriod = () => Date.now() >= start && Date.now() < end;
  if (!inPeriod()) return;
  const root = document.querySelector('[data-baroona-product-section]') || document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('[id^="MainProduct-"]');
  if (!root) return;
  const strings = config.strings;
  const variants = config.variants;
  const originals = new Map();
  const changedText = new Map();
  const renderedText = new Map();
  let mapping = {};
  let note;
  let frame = 0;
  let timer;
  let observer;
  const money = cents => '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const offerFor = id => {
    const variant = variants[String(id)];
    const rule = mapping[String(id)];
    if (!inPeriod() || !variant || !rule || !Number.isSafeInteger(variant.price) || rule[0] !== variant.price || ![0, 500, 526, 1000].includes(rule[1])) return null;
    return { id: String(id), price: variant.price, final: variant.price - Math.floor(variant.price * rule[1] / 10000), rate: rule[1], regular: variant.money };
  };
  const escape = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const markup = offer => offer.rate === 0
    ? `<span class="bbp-current">${escape(offer.regular)}</span><span class="bbp-label bbp-label--protected">${escape(strings.protected)}</span>`
    : `<span class="bbp-usual"><span class="visually-hidden">${escape(strings.usual)} </span><s>${escape(offer.regular)}</s></span><span class="bbp-offer">${money(offer.final)}</span><span class="bbp-label">${escape(strings.offer)}</span>`;
  function restore(el, id) {
    const record = originals.get(el);
    if (!record) return;
    if (el.querySelector('.bbp-label')) el.innerHTML = id && variants[String(id)] ? escape(variants[String(id)].money) : record.html;
    delete el.dataset.bbpRendered;
    delete el.dataset.bbpVariant;
    el.classList.remove('bbp-price');
    originals.delete(el);
  }
  function paint(el, id) {
    if (!el) return false;
    const offer = offerFor(id);
    if (!offer) { restore(el, id); return false; }
    const html = markup(offer);
    const previous = originals.get(el);
    if (!previous || previous.id !== String(id) || !el.querySelector('.bbp-label')) {
      originals.set(el, { id: String(id), html: escape(offer.regular) });
    }
    if (el.innerHTML !== html) el.innerHTML = html;
    if (!el.classList.contains('bbp-price')) el.classList.add('bbp-price');
    el.dataset.bbpRendered = 'true';
    el.dataset.bbpVariant = String(id);
    return offer.rate > 0;
  }
  function changeText(el, value) {
    if (!el) return;
    if (!changedText.has(el)) changedText.set(el, el.textContent);
    if (el.textContent !== value) el.textContent = value;
    renderedText.set(el, value);
  }
  function usualUnit(priceNode, offer) {
    const unit = priceNode?.parentElement?.querySelector('small');
    labelUsualUnit(unit, offer);
  }
  function labelUsualUnit(unit, offer) {
    if (!unit) return;
    if (!unit.textContent.trim()) { unit.classList.remove('bbp-inferred-unit'); return; }
    if (offer?.rate > 0 && variants[offer.id]?.hasUnit === false) { unit.classList.add('bbp-inferred-unit'); return; }
    unit.classList.remove('bbp-inferred-unit');
    const original = unit.textContent.startsWith(strings.usualUnit) ? (changedText.get(unit) || unit.textContent) : unit.textContent;
    if (changedText.has(unit) && !unit.textContent.startsWith(strings.usualUnit)) changedText.set(unit, original);
    if (offer && offer.rate > 0) changeText(unit, `${strings.usualUnit} ${original}`);
    else if (changedText.has(unit)) { unit.textContent = changedText.get(unit); changedText.delete(unit); }
  }
  function update() {
    frame = 0;
    if (!inPeriod()) { cleanup(); return; }
    observer?.disconnect();
    let hasOffer = false;
    const input = root.querySelector('input[data-variant-id]');
    if (input) {
      const sizeSelector = root.querySelector('[data-everyday-size-selector]');
      const sizeChoices = sizeSelector ? [...sizeSelector.querySelectorAll('[data-everyday-size-option]')] : [];
      if (Object.keys(variants).length === 2 && sizeChoices.length === 2 && root.querySelectorAll('[data-purchase-radio]').length === 2 && input.dataset.shelfVariantId && input.dataset.preorderVariantId && input.dataset.shelfVariantId !== input.dataset.preorderVariantId && variants[input.dataset.shelfVariantId] && variants[input.dataset.preorderVariantId]) {
        const shelfChoice = sizeChoices.find(button => button.dataset.shelfVariantId === input.dataset.shelfVariantId && !button.dataset.preorderVariantId && /^(shelf|everyday)( price)?$/i.test(button.querySelector('span')?.textContent.trim() || ''));
        const preChoice = sizeChoices.find(button => button.dataset.preorderVariantId === input.dataset.preorderVariantId && !button.dataset.shelfVariantId && /^pre[- ]?order( price)?$/i.test(button.querySelector('span')?.textContent.trim() || ''));
        if (shelfChoice && preChoice && shelfChoice !== preChoice) sizeSelector.classList.add('bbp-duplicate-purchase-options');
      }
      const slots = [
        ['[data-everyday-shelf-price]', input.dataset.shelfVariantId],
        ['[data-everyday-preorder-price]', input.dataset.preorderVariantId],
        ['[data-orderin-price]', input.dataset.orderinVariantId],
        ['[data-special-order-price]', input.dataset.specialOrderVariantId]
      ];
      slots.forEach(([selector, id]) => {
        const el = root.querySelector(selector);
        const active = paint(el, id);
        if (el && el.getClientRects().length) hasOffer = active || hasOffer;
        usualUnit(el, offerFor(id));
      });
      root.querySelectorAll('[data-safe-variant]').forEach(button => {
        const active = paint(button.querySelector('b'), button.dataset.safeVariant);
        if (button.getClientRects().length) hasOffer = active || hasOffer;
      });
      root.querySelectorAll('[data-single-price-variant]').forEach(button => {
        const active = paint(button.querySelector('b'), button.dataset.singlePriceVariant);
        if (button.getClientRects().length) hasOffer = active || hasOffer;
      });
      const singlePrice = root.querySelector('.baroona-single-price__price');
      if (singlePrice) hasOffer = paint(singlePrice, input.value) || hasOffer;
      root.querySelectorAll('[data-orderin-size-option]').forEach(button => {
        const active = paint(button.querySelector('strong'), button.dataset.variantId);
        if (button.getClientRects().length) hasOffer = active || hasOffer;
      });
      root.querySelectorAll('[data-everyday-size-option]').forEach(button => {
        const active = paint(button.querySelector('strong'), button.dataset.preorderVariantId || button.dataset.shelfVariantId);
        if (button.getClientRects().length) hasOffer = active || hasOffer;
      });
      root.querySelectorAll('.baroona-size-option__price').forEach(el => {
        const regular = changedText.get(el) || el.textContent;
        if (regular.includes('$')) changeText(el, `${strings.usualFrom} ${regular}`);
      });
      const shelf = root.querySelector('[data-purchase-type="shelf"]');
      const pre = root.querySelector('[data-purchase-type="preorder"]');
      if (offerFor(input.dataset.shelfVariantId)?.rate) changeText(shelf?.querySelector('.baroona-panel-label'), strings.shelfOption);
      if (offerFor(input.dataset.preorderVariantId)?.rate) {
        changeText(pre?.querySelector('.baroona-panel-label'), strings.preorderOption);
        changeText(pre?.querySelector('.baroona-panel-ribbon'), strings.preorderRibbon);
      }
      if (offerFor(input.dataset.preorderVariantId)?.rate || offerFor(input.dataset.shelfVariantId)?.rate) {
        const saving = pre?.querySelector('em');
        if (saving) changeText(saving, `${strings.usualSaving} ${changedText.get(saving) || saving.textContent}`);
      }
    } else {
      const selected = root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || config.selectedVariant;
      const special = root.querySelector('.baroona-special-order-price__amount');
      if (special) {
        hasOffer = paint(special, selected) || hasOffer;
        labelUsualUnit(root.querySelector('.baroona-special-order-unit-price'), offerFor(selected));
      }
      const legacy = root.querySelector('[data-baroona-preorder]');
      if (legacy) {
        const shelf = legacy.querySelector('.baroona-shelf-price');
        const pre = legacy.querySelector('.baroona-hero-price');
        hasOffer = paint(shelf, legacy.dataset.shelfVariantId) || hasOffer;
        const preId = legacy.dataset.preorderVariantId || selected;
        hasOffer = paint(pre, preId) || hasOffer;
        labelUsualUnit(shelf?.closest('.baroona-price-row')?.querySelector('.baroona-unit-price'), offerFor(legacy.dataset.shelfVariantId));
        labelUsualUnit(pre?.closest('.baroona-price-row')?.querySelector('.baroona-unit-price'), offerFor(preId));
        if (offerFor(preId)?.rate || offerFor(legacy.dataset.shelfVariantId)?.rate) legacy.querySelectorAll('.baroona-saving-strip > span,.baroona-saving-strip > strong').forEach(el => changeText(el, `${strings.usualSaving} ${changedText.get(el) || el.textContent}`));
      }
      const container = root.querySelector('[id^="price-"]');
      const regular = container?.querySelector('.price');
      const offer = offerFor(selected);
      let panel = container?.querySelector('[data-bbp-standard]');
      if (container && regular && offer) {
        if (!panel) { panel = document.createElement('div'); panel.dataset.bbpStandard = 'true'; container.append(panel); }
        hasOffer = paint(panel, selected) || hasOffer;
        regular.classList.add('bbp-standard-original');
      } else {
        panel?.remove();
        regular?.classList.remove('bbp-standard-original');
      }
    }
    if (hasOffer) {
      if (!note || !note.isConnected) {
        note = document.createElement('aside');
        note.className = 'bbp-note';
        note.setAttribute('aria-label', strings.noteTitle);
        const title = document.createElement('strong'); title.textContent = strings.noteTitle;
        const copy = document.createElement('p'); copy.textContent = strings.note;
        const link = document.createElement('a'); link.href = config.termsUrl; link.textContent = strings.terms;
        note.append(title, copy, link);
        const anchor = root.querySelector('.baroona-buy-row') || root.querySelector('product-form');
        if (anchor) anchor.before(note); else root.append(note);
      }
    } else { note?.remove(); }
    observer?.observe(root, { childList: true, subtree: true, characterData: true });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function onVisibility() { if (!document.hidden) schedule(); }
  function cleanup() {
    observer?.disconnect();
    clearTimeout(timer);
    cancelAnimationFrame(frame);
    for (const el of originals.keys()) restore(el);
    for (const [el, text] of changedText) { if (el.textContent === renderedText.get(el)) el.textContent = text; }
    renderedText.clear();
    changedText.clear();
    root.querySelectorAll('.bbp-inferred-unit').forEach(el => el.classList.remove('bbp-inferred-unit'));
    root.querySelectorAll('.bbp-duplicate-purchase-options').forEach(el => el.classList.remove('bbp-duplicate-purchase-options'));
    root.querySelectorAll('[data-bbp-standard]').forEach(el => el.remove());
    root.querySelectorAll('.bbp-standard-original').forEach(el => el.classList.remove('bbp-standard-original'));
    note?.remove();
    root.removeEventListener('click', schedule);
    root.removeEventListener('change', schedule);
    window.removeEventListener('pageshow', schedule);
    window.removeEventListener('popstate', schedule);
    document.removeEventListener('visibilitychange', onVisibility);
  }
  function armExpiry() {
    const remaining = end - Date.now();
    if (remaining <= 0) { cleanup(); return; }
    timer = setTimeout(() => { if (inPeriod()) armExpiry(); else cleanup(); }, Math.min(remaining, 2147000000));
  }
  fetch(config.mapUrl, { credentials: 'omit' }).then(response => {
    if (!response.ok) throw new Error('Offer map unavailable');
    return response.json();
  }).then(data => {
    if (data.version !== 1 || data.startsAt !== config.startsAt || data.endsAt !== config.endsAt || !inPeriod()) return;
    mapping = data.products?.[config.productId] || {};
    if (!Object.keys(mapping).length) return;
    observer = new MutationObserver(schedule);
    root.addEventListener('click', schedule);
    root.addEventListener('change', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('popstate', schedule);
    document.addEventListener('visibilitychange', onVisibility);
    update();
    armExpiry();
  }).catch(() => {});
})();
